<template>
  <v-card class="pa-2" max-width="374">
    <v-sheet>
      <v-card-title>Mileage Details</v-card-title>

      <v-card-text>
        <div class="my-4 text-h4 text-center  green--text">$ {{ amount }}</div>

        <div class="text-center mt-n4">
          Reimbursement Amount
        </div>
      </v-card-text>
    </v-sheet>

    <v-divider class="mt-5"></v-divider>

    <v-card-text class="mt-3">
      <v-list-item class="grow ml-n5">
        <v-icon class="mr-1">
          mdi-calendar-month
        </v-icon>
        <span class="subheading mr-2">Date Period</span>
        <v-row align="center" justify="end">
          <span class="subheading">{{ datePeriod }}</span>
        </v-row>
      </v-list-item>
      <v-list-item class="grow ml-n5">
        <v-icon class="mr-1">
          mdi-finance
        </v-icon>
        <span class="subheading mr-2">Status</span>
        <v-row align="center" justify="end">
          <span class="subheading">{{
            closeOut ? "Close Out" : "Active"
          }}</span>
        </v-row>
      </v-list-item>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment";

export default {
  props: {
    amount: {
      type: String,
    },
    date: {
      type: Array,
    },
    closeOut: {
      type: Boolean,
    },
  },

  computed: {
    datePeriod() {
      let earliestDate = new Date(Math.min.apply(null, this.date));
      let latestDate = new Date(Math.max.apply(null, this.date));
      let datePeriod = "";

      if ((earliestDate && latestDate) == "Invalid Date") {
        return null;
      }

      if (Date.parse(earliestDate) == Date.parse(latestDate)) {
        return (datePeriod = `${moment(earliestDate).format(
          "DD MMM"
        )} - Present`);
      }

      datePeriod = `${moment(earliestDate).format("DD MMM")} - ${moment(
        latestDate
      ).format("DD MMM")}`;

      return datePeriod;
    },
  },
};
</script>
